/**
 * Contact — static support-contact page (Day 100). The email below is a
 * placeholder using the verified ironcladsupply.co domain (the Resend sender per
 * ENVIRONMENT.md); confirm the real support address at launch.
 */
import { type JSX } from 'react';
import { Mail } from 'lucide-react';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const SUPPORT_EMAIL = 'arbi@ironcladsupply.co';

export default function Contact(): JSX.Element {
  useDocumentTitle('Contact');
  return (
    <div className="h-full overflow-auto">
      <div className="max-w-3xl mx-auto p-6 space-y-5">
        <div className="flex items-center gap-2">
          <Mail size={18} className="text-accent" />
          <h1 className="text-xl font-semibold text-ink-bright">Contact</h1>
        </div>

        <section className="arbi-card p-5 space-y-2">
          <p className="text-sm text-ink-secondary">
            Need help or have a question about Arbi? Reach out to your Arbi administrator, or email
            the team:
          </p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="text-sm text-accent hover:underline underline-offset-2"
          >
            {SUPPORT_EMAIL}
          </a>
          <p className="text-xs text-ink-muted pt-1">
            Include your account email and a description of what you were doing so we can help
            faster.
          </p>
        </section>
      </div>
    </div>
  );
}
